// Libraries
import { FC } from "react";

// Icons
import {
  AiOutlineAlert,
  AiOutlineCheckCircle,
  AiOutlineInfoCircle,
  AiOutlineWarning,
} from "react-icons/ai";

// Types
import { FieldMessageProps, MessageConfig } from "./FieldMessage.types";
import classNames from "classnames";

const iconMap: Record<string, MessageConfig> = {
  error: { icon: <AiOutlineAlert />, textColor: "text-danger", text: "text-regular-3" },
  warning: { icon: <AiOutlineWarning />, textColor: "text-warning", text: "text-regular-3" },
  success: { icon: <AiOutlineCheckCircle />, textColor: "text-success", text: "text-regular-3" },
  info: { icon: <AiOutlineInfoCircle />, textColor: "text-info", text: "text-regular-3" },
  default: { icon: undefined, textColor: "", text: "text-regular-2" },
};

const alignMap: Record<string, string> = {
  left: "text-start",
  center: "text-center",
  right: "text-end",
};

export const FieldMessage: FC<FieldMessageProps> = ({
  message,
  type = "default",
  align = "center",
  className = "",
}) => {
  const { icon, textColor, text } = iconMap[type];

  return (
    <div
      className={classNames(
        className,
        text,
        textColor,
        `flex gap-1 items-center ${alignMap[align]}`
      )}
    >
      {icon}
      {message}
    </div>
  );
};
